import { Injectable } from '@angular/core';
import {MainboardItem} from '../vod/models/mainboard-item';
import {Observable} from 'rxjs/Observable';
import {BaseDataService} from '../commons/base-data.service';
import {HelpersService} from '../../core/helpers/helpers.service';
import { CustomerServicesService, ProductP, ProductServicesService } from '../crm-client-api';

@Injectable()
export class SubscriptionDataService extends BaseDataService {

  constructor(private rest: ProductServicesService,
              helpers: HelpersService) {
    super(helpers);
  }

  getActiveProducts(): Observable<ProductP[]> {
    return this.rest.getAllActiveProducts().map(response => {
      if (response.code === 200) {
        return <ProductP[]>response.data;
      } else {
        // this.helpers.logger.error(response);
        // TODO popup error
        return [];
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/subscription/subscription-data.service.ts